import { useQuery } from "@tanstack/react-query";

// Helpers
import { getOEMFranchisesLabels } from "@/Common/helpers/OEMs";

// API's
import { getModels } from "@/Common/api/vehicles";

const normalizeExpr = / Cars\b| Trucks\b/g;

function useModelsByMake(make = "") {
	const { data, isLoading } = useQuery({
		queryKey: ["models", make],
		queryFn: () => getModels(make),
		enabled: !!make,
		staleTime: Infinity,
	});

	return {
		isLoading,
		models: data || [],
	};
}

const normalizeFranchise = (make = "") => make.replace(normalizeExpr, "").trim();

function useMakes(location, modelKey, makes = []) {
	if (modelKey !== "new") {
		return makes ?? [];
	}
	const franchises = getOEMFranchisesLabels(location?.oems || []);
	const normalizedFranchises = franchises?.map((franchise) => normalizeFranchise(franchise)) ?? [];
	return makes?.filter((element) => normalizedFranchises?.includes(element.make));
}

export { useModelsByMake, useMakes };
